var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductIa5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 258,
    viewBox: "0 0 265 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 123.493,
    height: 121.288,
    rx: 19,
    fill: "url(#paint0_linear_839_4)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.82031,
    y: 78.6536,
    width: 41.8995,
    height: 27.1979,
    rx: 4,
    fill: "#F8F8F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56.6016,
    y: 78.6536,
    width: 41.8995,
    height: 27.1979,
    rx: 4,
    fill: "#F8F8F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.62988,
    y: 12.4966,
    width: 42.0367,
    height: 6.91743,
    rx: 3.45871,
    fill: "#F8F8F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.82031,
    y: 30.8735,
    width: 60.2765,
    height: 4.41048,
    rx: 2.20524,
    fill: "#F8F8F8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.82031,
    y: 40.4292,
    width: 60.2765,
    height: 4.41048,
    rx: 2.20524,
    fill: "#F8F8F8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.82031,
    y: 49.9854,
    width: 60.2765,
    height: 4.41048,
    rx: 2.20524,
    fill: "#F8F8F8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.82031,
    y: 59.5415,
    width: 60.2765,
    height: 4.41048,
    rx: 2.20524,
    fill: "#F8F8F8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 135.255,
    width: 123.493,
    height: 121.288,
    rx: 19,
    fill: "url(#paint1_linear_839_4)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 8.82031,
    y: 213.908,
    width: 41.8995,
    height: 27.1979,
    rx: 4,
    fill: "#F8F8F8"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 56.6016,
    y: 213.908,
    width: 41.8995,
    height: 27.1979,
    rx: 4,
    fill: "#F8F8F8"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 8.62988,
    y: 147.751,
    width: 42.0367,
    height: 6.91743,
    rx: 3.45871,
    fill: "#F8F8F8"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 8.82031,
    y: 166.128,
    width: 60.2765,
    height: 4.41048,
    rx: 2.20524,
    fill: "#F8F8F8"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 8.82031,
    y: 175.684,
    width: 60.2765,
    height: 4.41048,
    rx: 2.20524,
    fill: "#F8F8F8"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 8.82031,
    y: 185.24,
    width: 60.2765,
    height: 4.41048,
    rx: 2.20524,
    fill: "#F8F8F8"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 8.82031,
    y: 194.796,
    width: 60.2765,
    height: 4.41048,
    rx: 2.20524,
    fill: "#F8F8F8"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 141.135,
    y: 0.735352,
    width: 123.493,
    height: 121.288,
    rx: 19,
    fill: "url(#paint2_linear_839_4)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 152.161,
    y: 86.7397,
    width: 91.1499,
    height: 27.1979,
    rx: 4,
    fill: "#F8F8F8"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 152.161,
    y: 10.2913,
    width: 61.7467,
    height: 27.1979,
    rx: 4,
    fill: "#F8F8F8"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 152.161,
    y: 45.5752,
    width: 91.1499,
    height: 4.41048,
    rx: 2.20524,
    fill: "#F8F8F8"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 152.161,
    y: 55.1313,
    width: 91.1499,
    height: 4.41048,
    rx: 2.20524,
    fill: "#F8F8F8"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 152.161,
    y: 64.687,
    width: 91.1499,
    height: 4.41048,
    rx: 2.20524,
    fill: "#F8F8F8"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 152.161,
    y: 74.2432,
    width: 91.1499,
    height: 4.41048,
    rx: 2.20524,
    fill: "#F8F8F8"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 141.135,
    y: 135.99,
    width: 123.493,
    height: 121.288,
    rx: 19,
    fill: "url(#paint3_linear_839_4)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 152.161,
    y: 221.994,
    width: 91.1499,
    height: 27.1979,
    rx: 4,
    fill: "#F8F8F8"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 152.161,
    y: 145.546,
    width: 61.7467,
    height: 27.1979,
    rx: 4,
    fill: "#F8F8F8"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 152.161,
    y: 180.83,
    width: 91.1499,
    height: 4.41048,
    rx: 2.20524,
    fill: "#F8F8F8"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 152.161,
    y: 190.386,
    width: 91.1499,
    height: 4.41048,
    rx: 2.20524,
    fill: "#F8F8F8"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 152.161,
    y: 199.942,
    width: 91.1499,
    height: 4.41048,
    rx: 2.20524,
    fill: "#F8F8F8"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 152.161,
    y: 209.498,
    width: 91.1499,
    height: 4.41048,
    rx: 2.20524,
    fill: "#F8F8F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_839_4",
    x1: 61.7467,
    y1: 0,
    x2: 61.7467,
    y2: 121.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_839_4",
    x1: 61.7467,
    y1: 135.255,
    x2: 61.7467,
    y2: 256.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_839_4",
    x1: 202.881,
    y1: 0.735352,
    x2: 202.881,
    y2: 122.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_839_4",
    x1: 202.881,
    y1: 135.99,
    x2: 202.881,
    y2: 257.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIa5);
export default __webpack_public_path__ + "static/media/product-ia-5.17c2e2faa1b5394fbba58bec7bd730d8.svg";
export { ForwardRef as ReactComponent };